import { YaNative } from '@yanolja-rnd/ya-native'
import { TCanceledIds, TCategoryIds } from '~/pages/order-cancel/[orderId]'

export const isNative = (
  yaNative:
    | YaNative
    | {
        isEnabled: false
      }
): yaNative is YaNative => yaNative.isEnabled

const isTCategoryIds = (input): input is TCategoryIds => {
  return (
    !!input &&
    Array.isArray(input.property) &&
    input.property.every(item => typeof item === 'string') &&
    Array.isArray(input.leisure) &&
    input.leisure.every(item => typeof item === 'string') &&
    Array.isArray(input.train) &&
    input.train.every(item => typeof item === 'string') &&
    Array.isArray(input.bus) &&
    input.bus.every(item => typeof item === 'number')
  )
}

export const isTCanceledIds = (input): input is TCanceledIds => {
  return (
    !!input && isTCategoryIds(input.cancelSucceededIds) && isTCategoryIds(input.cancelFailedIds)
  )
}
